import type { LoginAuthorizeData } from '@/features/auth/services/use-mutation-login-authorize';

export type UsersSchema = Pick<
  LoginAuthorizeData,
  'id' | 'name' | 'email' | 'roles' | 'token' | 'refreshToken' | 'tenantId'
> & {
  tokenExpiredAt: Date;
  practitionerTypeCode?: string;
  practitionerTypeName?: string;
  superAdminFlag?: boolean;
};

export const usersSchema =
  '&id, name, email, roles, token, refreshToken, tenantId, tokenExpiredAt';
